// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WellsTable__controls___hWyIc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 1.2rem;
}

.WellsTable__actions___tGGtu {
    display: flex;
}

.WellsTable__vspCell___UtHwt {
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    min-width: 0;
    max-width: 28rem;
}

.WellsTable__vspName___LIA_B {
    width: 25rem;
    max-width: 25rem;
}

.WellsTable__wellsTable___Js6mx {
    overflow-x: hidden;
}

.WellsTable__wellNameCell___vfMkp {
    display: flex;
    gap: 0.8rem;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/SpeedLawsModal/components/WellsTable/WellsTable.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;;IAE9B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".controls {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.4rem 1.2rem;\n}\n\n.actions {\n    display: flex;\n}\n\n.vspCell {\n    display: flex;\n    flex: 1;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n\n    min-width: 0;\n    max-width: 28rem;\n}\n\n.vspName {\n    width: 25rem;\n    max-width: 25rem;\n}\n\n.wellsTable {\n    overflow-x: hidden;\n}\n\n.wellNameCell {\n    display: flex;\n    gap: 0.8rem;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controls": `WellsTable__controls___hWyIc`,
	"actions": `WellsTable__actions___tGGtu`,
	"vspCell": `WellsTable__vspCell___UtHwt`,
	"vspName": `WellsTable__vspName___LIA_B`,
	"wellsTable": `WellsTable__wellsTable___Js6mx`,
	"wellNameCell": `WellsTable__wellNameCell___vfMkp`
};
export default ___CSS_LOADER_EXPORT___;
